import { render } from "./EmailMarketing.vue?vue&type=template&id=05ef1ee1&scoped=true"
import script from "./EmailMarketing.vue?vue&type=script&lang=js"
export * from "./EmailMarketing.vue?vue&type=script&lang=js"

import "./EmailMarketing.vue?vue&type=style&index=0&id=05ef1ee1&scoped=true&lang=css"

import exportComponent from "G:\\BWD\\BWD-NEW-05-04-2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05ef1ee1"]])

export default __exports__